import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl10049ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .max(
          new Date(),
          t(
            "Η ημερομηνία απόφασης οργάνου δεν μπορεί να είναι μεταγενέστερη της ημερομηνίας υποβολής της αίτησης.",
          ),
        )
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      totalActive: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      businessCircle: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^(-)?[0-9]+(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      employees: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      usageFromDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      usageToDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      nextUsageFromDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      nextUsageToDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      fuXbrlFiles: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocWeb: yup.string().nullable(),
      webDate: yup.date().nullable(),
      webURL: yup.string().url(t("Το πεδίο πρέπει να είναι url")).nullable(),
    })
    .test(
      "has filled all of website",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      (value) => {
        if (value?.fudocWeb || value?.webDate || value?.webURL) {
          return !!value?.fudocWeb && !!value?.webDate && !!value?.webURL;
        } else {
          return true;
        }
      },
    )
    .test(
      "You have not entered auditors",
      t("Δεν έχετε δηλώσει κάποια ελεγκτική εταιρεία ή ελεγκτή."),
      (value) => {
        if (
          value?.auditCompanies?.length > 0 ||
          value?.auditPersons?.length > 0
        ) {
          return true;
        } else {
          return false;
        }
      },
    )
    .test(
      "You have not filled all auditor fields",
      t("Υπάρχει μη συμπληρωμένο υποχρεωτικό πεδίο στους ελεγκτές"),
      (value) => {
        const auditPersons = value.auditPersons;

        if (auditPersons) {
          for (let person of auditPersons) {
            if (
              !person.afm ||
              !person.auditorTypes ||
              !person.elteNumber ||
              !person.firstName ||
              !person.lastName ||
              !person.fathersName
            ) {
              return false;
            }
          }
        }

        return true;
      },
    )
    .test(
      "You have not filled all auditCompanies fields",
      t("Υπάρχει μη συμπληρωμένο υποχρεωτικό πεδίο στις ελεγκτικές εταιρείες"),
      (value) => {
        const auditCompanies = value.auditCompanies;

        if (auditCompanies) {
          for (let company of auditCompanies) {
            if (!company.descr || !company.gemiNumber) {
              return false;
            }
          }
        }
        return true;
      },
    );
};
